import { Form } from 'react-bootstrap';

const SignpostModalItem = ({ dataTestId, item, prop, onChange, label, readonly = false }: any) => {
  const { Group, Label, Control } = Form;
  return (
    <Group className="mb-3" controlId={prop}>
      <Label>{label}</Label>
      <Control
        data-testid={dataTestId}
        type="text"
        value={item[prop] || ''}
        onChange={onChange}
        readOnly={readonly}
      />
    </Group>
  );
};

export { SignpostModalItem };
